interface Props {
  className?: string;
}

export default function ProfileIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 11 11"
      fill="white"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.419199 10.6C0.643149 8.2755 2.79992 6.4 5.5 6.4C8.20008 6.4 10.3569 8.2755 10.5808 10.6H5.5H0.419199Z"
        stroke="currentColor"
        fill="white"
        strokeWidth="0.8"
      />
      <circle
        cx="5.5"
        cy="3"
        r="1.9"
        fill="white"
        stroke="currentColor"
        strokeWidth="0.8"
      />
    </svg>
  );
}
